import HeaderComponents from "segments/desktop/header";
import FooterComponents from "segments/desktop/footer";
import BannerComponents from "segments/desktop/banner";
import DevlinkComponents from "segments/desktop/devlink";
import AssetComponents from "segments/desktop/asset";
import SegmentFamilies from "constants/segment-families";
export const isHeaderComponent = (segmentComponentName)=>{
    return HeaderComponents[segmentComponentName];
};
export const isFooterComponent = (segmentComponentName)=>{
    return FooterComponents[segmentComponentName];
};
export const isBannerComponent = (segmentComponentName)=>{
    return BannerComponents[segmentComponentName];
};
export const isDevlinkComponent = (segmentComponentName)=>{
    return DevlinkComponents[segmentComponentName];
};
export const isAssetComponent = (segmentComponentName)=>{
    return AssetComponents[segmentComponentName];
};
export const isMainContentComponent = (segmentComponentName)=>{
    return !isHeaderComponent(segmentComponentName) && !isFooterComponent(segmentComponentName) && !isBannerComponent(segmentComponentName) && !isAssetComponent(segmentComponentName) && !isDevlinkComponent(segmentComponentName);
};
